import { render, staticRenderFns } from "./BaseButtonToggleable.vue?vue&type=template&id=746626c2&scoped=true&"
import script from "./BaseButtonToggleable.vue?vue&type=script&lang=js&"
export * from "./BaseButtonToggleable.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonToggleable.vue?vue&type=style&index=0&id=746626c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746626c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBadge,VCol,VRow})
